import React from 'react';
import { Image, ImageStyle, StyleProp } from 'react-native';

interface RemoveIconProps {
  width?: number;
  style?: StyleProp<ImageStyle>;
}

const RemoveIcon: React.FC<RemoveIconProps> = ({ width = 50, style }) => {
  return (
    <Image
      source={require('@/assets/images/RemoveCode.png')}
      style={[{ width: width, height: width }, style]}
    />
  );
};

export default RemoveIcon;
